import { CodeRequest } from "./code-request";

export class TrainingAttestationDetailRequest {
  public providerTaxId: string;
  public codeRequest: CodeRequest;
}
